export default __webpack_public_path__ + "static/logo20-09a4c8442d62b10250fff702c740f68b.png";